import React, { useEffect, useState } from "react";
import { RETAIL_QUOTES } from "../data/retailQuotes";

const pickRandomIndex = (excludeIdx, len) => {
  if (len <= 1) return 0;
  let i = Math.floor(Math.random() * len);
  if (i === excludeIdx) i = (i + 1) % len;
  return i;
};

export default function RotatingRetailQuote() {
  const [i, setI] = useState(() => Math.floor(Math.random() * RETAIL_QUOTES.length));
  useEffect(() => {
    const id = setInterval(() => setI((c) => pickRandomIndex(c, RETAIL_QUOTES.length)), 10000);
    return () => clearInterval(id);
  }, []);
  return (
    <h1
      key={i}
      className="font-heading text-4xl sm:text-5xl lg:text-6xl xl:text-7xl font-medium tracking-tight leading-[1.04] text-balance animate-quote-in"
      data-testid="retail-rotating-quote"
    >
      {RETAIL_QUOTES[i]}
    </h1>
  );
}
